import Page from './index.vue';
export default Page;